<template>
  <div class="my-info-page mt-4">
    <app-page-header
      title="Meus dados"
      subtitle="Mantenha seus dados cadastrais atualizados e garanta sua participação."
    ></app-page-header>

    <div class="row">
      <div class="col-12">
        <user-form
          @submit="onSubmit"
          :firstAccess="false"
          :errors="errors"
          :isSaving="isSaving"
        ></user-form>
      </div>
    </div>
  </div>
</template>

<script>
import ClientService from '@/services/client.service';
import UserForm from '@/components/Forms/User/UserForm.vue';
import { UPDATE_USER } from '@/store/actions/auth';

export default {
  name: 'my-info-page',
  components: {
    UserForm,
  },
  data: () => {
    return {
      isSaving: false,
      errors: {},
    };
  },
  methods: {
    onSubmit(data) {
      this.isSaving = true;
      this.errors = {};

      ClientService.update(data.id, data)
        .then(() => {
          this.toastify('Dados atualizados com sucesso!');

          this.$store.dispatch(UPDATE_USER, {
            name: data.name,
            picture: data.picture,
            email: data.email,
          });
        })
        .catch(({ response }) => {
          const { message, errors } = response.data;

          if (response.status === 422) this.errors = errors;
          else
            this.toastify(
              message || 'Erro ao tentar atualizar dados.',
              'error'
            );
        })
        .finally(() => (this.isSaving = false));
    },
  },
};
</script>
